<template>
  <div v-if="applications.length === 0" class="wrapper">
    <div class="align-center">
      <el-card>
        <h3>Looks like you don't have deployed anything ...</h3>

        <img src="../assets/hero/nothing-applications.svg" class="nothing" />

        <p>
          <el-button type="primary" @click.prevent="$router.push('/create')">Create an Application</el-button>
        </p>
      </el-card>
    </div>
  </div>

  <div v-else id="incidents" class="wrapper">
    <h2>
      Incidents
      <el-button type="primary" @click="$router.push('/create')">Report a new incident</el-button>
    </h2>

    <el-table
      id="instances-list"
      :data="incidents"
      :default-sort="defaultSort"
      :row-class-name="className"
      size="small"
    >
      <el-table-column width="38px" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.resolved" class="el-icon-success" />
          <i v-else class="el-icon-warning" />
        </template>
      </el-table-column>

      <el-table-column label="Application">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="$router.push('/instances/' + scope.row.instanceId)"
          >
            <strong>{{ getApplication(scope.row.applicationId).config.hostname }}</strong>
          </el-button>
          <div>{{ scope.row.cause }}</div>
        </template>
      </el-table-column>

      <el-table-column label="Information" prop="comment" />

      <el-table-column label="Started" prop="started" width="195px">
        <template slot-scope="scope">
          {{ toCalendar(scope.row.started) }}
        </template>
      </el-table-column>

      <el-table-column width="195px">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.resolved" type="success">Resolved</el-tag>
          <template v-else>
            Ongoing &mdash; {{ fromNow(scope.row.started) }}
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
  },
  data () {
    return {
      create: false,
      defaultSort: {
        prop: 'started',
        order: 'descending'
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    ...mapState(['instances', 'applications', 'incidents']),
    ...mapGetters(['permission'])
  },
  methods: {
    getApplication (applicationId) {
      return this.applications.find((a) => a.id === applicationId)
    },
    className ({ row }) {
      if (!row.resolved) {
        return 'alarm'
      }
    }
  },
  beforeMount () {
    if (this.permission('accounting')) {
      this.$router.push('/billing')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  .el-icon-success {
    color: $--color-success;
  }
  .el-icon-warning {
    color: $--color-danger;
  }
  .nothing {
    max-height: 300px;
    padding: 50px 0;
    margin-top: 50px;
  }
  .el-button--text {
    color: $--button-info-background-color;
    font-weight: 500;

    &:hover, &:focus {
      color: $--color-primary;
    }
  }
</style>

<style lang="scss">
  @import "../theme";

  #incidents {
    .el-table .alarm {
      background: oldlace;
    }
  }
</style>
